export class PreSelectedBulkMenu {
    zoneLabel: string = "";
    subMarketLabel: string = "";
}